/**
 * Account-panel UI state.
 *
 * Tracks whether the slide-in panel is open and which sub-view it
 * shows (`main` / `iban` / `email`). The PortalHeader's user-menu
 * dispatches into this store; HomeView's "Modifica IBAN" link and
 * PaymentsView's "Modifica IBAN" CTA call `open('iban')` directly.
 *
 * Replaces the design-bundle's `window.__openAccount` global with a
 * proper Pinia store so views can subscribe and the reactivity
 * survives HMR.
 */
import { ref } from 'vue'
import { acceptHMRUpdate, defineStore } from 'pinia'

export type AccountPanelView = 'main' | 'iban' | 'email'

export const useAccountPanelStore = defineStore('accountPanel', () => {
  const isOpen = ref(false)
  const view = ref<AccountPanelView>('main')

  function open(v: AccountPanelView = 'main'): void {
    view.value = v
    isOpen.value = true
  }

  function close(): void {
    isOpen.value = false
  }

  function setView(v: AccountPanelView): void {
    view.value = v
  }

  return { isOpen, view, open, close, setView }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAccountPanelStore, import.meta.hot))
}
